export default __webpack_public_path__ + "static/media/DoneTick.46fd887a.svg";